import _ from 'lodash'
import {
    SAVE_ALL_UI,
    SET_LAUNCH_DELAY,
    SET_AUTO_LAUNCH_ON_LOGIN,
    SET_AUTO_LAUNCH_ON_STARTUP,
    SET_LAYOUT,
} from './constants'

const initialState = {
    autoLaunchOnLogin: false,
    autoLaunchOnStartup: false,
    launchDelay: 2,
    layout: 'default', // 'left', 'right', 'default'
}

export default function uiSettings(state = initialState, action) {
    switch (action.type) {
        // Update launcher ui settings
        case SAVE_ALL_UI: {
            // We only want to add keys that already exist in the state object
            let newState = _.pick(action.payload, _.keys(state))
            newState = { ...state, ...newState }

            // Migration fix, make sure to read in the value of autoLaunch as autoLaunchOnLogin
            if (action.payload.autoLaunch != null) {
                newState.autoLaunchOnLogin = action.payload.autoLaunch
            }
            return newState
        }

        case SET_LAUNCH_DELAY: {
            return {
                ...state,
                launchDelay: action.payload,
            }
        }

        case SET_AUTO_LAUNCH_ON_LOGIN: {
            return {
                ...state,
                autoLaunchOnLogin: action.payload,
            }
        }

        case SET_AUTO_LAUNCH_ON_STARTUP: {
            return {
                ...state,
                autoLaunchOnStartup: action.payload,
            }
        }

        case SET_LAYOUT: {
            return {
                ...state,
                layout: action.payload,
            }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/ui/reducers.js